import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { ISectionListParams } from 'core/model/interfaces/static-pages';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { removeEmptyValues } from 'shared/utils/object.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IStaticPagesState } from '../types';

export const fetchSectionList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchSectionList`,
  async (params: ISectionListParams, { getState }) => {
    const { staticPages } = getState();
    return apiService.staticPages.getSectionList(
      removeEmptyValues({
        ...params,
        page: staticPages.sectionList.pagination.currentPage,
      }),
    );
  },
);

export const fetchSectionListReducer: TSliceExtraReducer<IStaticPagesState> = builder =>
  builder
    .addCase(fetchSectionList.pending, state => {
      state.sectionList.isLoading = true;
    })
    .addCase(fetchSectionList.rejected, state => {
      state.sectionList.isLoading = false;
      state.sectionList.pagination = DEFAULT_PAGINATION;
      state.sectionList.data = [];
    })
    .addCase(fetchSectionList.fulfilled, (state, { payload }) => {
      state.sectionList.data = payload.sections;
      state.sectionList.pagination = payload.pagination;
      state.sectionList.isLoading = false;
    });
